import React from 'react';
import { Box, Typography } from '@mui/material';
import { IBadgeResponse } from '../../../../../interfaces/badge.interface';

interface IUserBadgeProps {
  badge: IBadgeResponse;
}
const UserBadge = (props: IUserBadgeProps) => {
  const { badge } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap={'12px'}
      justifyContent="center"
      alignItems="center"
      padding="16px 0"
      sx={{ bgcolor: 'background.light' }}
      textAlign="center"
      width="100%"
    >
      <Box
        component="img"
        alt={badge.name}
        src={badge.fileUrl || ''}
        sx={{ width: '3.4rem', height: '4.2rem' }}
      />
      <Typography variant="body4" maxWidth={'5rem'} lineHeight={'140%'}>
        {badge.title}
      </Typography>
    </Box>
  );
};

export default UserBadge;
